import { Divider } from '../Divider';

export const SidebarDivider = () => (
  <Divider rcx-sidebar-v2--divider mbs={-2} mbe={0} />
);
